import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  InputBase,
  Button,
  Box,
  Slide,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  useMediaQuery,
  Modal,
  Menu,
  MenuItem,
  Paper,
  Badge,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputAdornment,
  Alert,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SearchIcon from "@mui/icons-material/Search";
import PlaceIcon from "@mui/icons-material/Place";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PersonIcon from "@mui/icons-material/Person";
import RoomIcon from "@mui/icons-material/Room";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import EmailIcon from "@mui/icons-material/Email";
import { useNavigate, Link } from "react-router-dom";
import {
  getLocation,
  setModalProperties,
  getAppToken,
  getCustomerId,
  getUserLoginNumber,
} from "../../store/actions/userActions";
import {
  GoogleMap,
  Marker,
  useLoadScript,
  MarkerF,
  InfoWindowF,
} from "@react-google-maps/api";
import { styled } from "@mui/joy/styles";
import { useDispatch, useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch } from "../../hooks";
import {
  buildListingShopPath,
  buildShopPath,
} from "../../utils/functionalOperations";
import StoreIcon from "@mui/icons-material/Store";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
// import { Sthaick } from "../../../public/Sthanick.jpeg";

const libraries = ["places"];
const HeaderContainer = styled(Box)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  transition: "transform 0.5s ease-in-out",
});

const Header = (onLocationConfirm) => {
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const geocoderRef = useRef(null);
  const [searchInput, setSearchInput] = useState("");
  const autocompleteServiceRef = useRef(null);
  const [showHeader, setShowHeader] = useState(true);
  const [prevScrollPos, setPrevScrollPos] = useState(window.pageYOffset);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [error, setError] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [errors, setErrors] = useState({});
  const [searchLocation, setSearchLocation] = useState("");
  const isSmallScreen = useMediaQuery("(max-width:767px)");
  const [isInfoWindowOpen, setInfoWindowOpen] = useState(false);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [mapCenter, setMapCenter] = useState({ lat: 0, lng: 0 });
  const autocompleteRef = useRef(null);
  const [location, setLocation] = useState(""); // To store address
  const [inputValue, setInputValue] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const [query, setQuery] = useState("");
  const [openDropdown, setOpenDropdown] = useState(false);
  const autocompleteService = useRef(null);
  const containerRef = useRef(null);
  const [url, setUrl] = useState("");
  const debounceTimer = useRef(null);
  const sessionToken = useRef(null);
  const dispatch = useDispatch();
  const customerId = useSelector((state) => state?.user?.customerId);
  const cartData = useSelector((state) => state?.user?.cartDetails);
  const apptoken = useSelector((state) => state.user.apptoken);

  const changedAddress = useSelector(
    (state) => state.user?.userLocation?.changedAddress ?? null,
  );
  const [formattedAddress, setFormattedAddress] = useState(changedAddress);

  // Join Us / Become a Vendor Modal State
  const [isJoinUsOpen, setIsJoinUsOpen] = useState(false);
  const [joinPhone, setJoinPhone] = useState("");
  const [joinOtp, setJoinOtp] = useState(["", "", "", "", "", ""]);
  const [joinPhoneError, setJoinPhoneError] = useState("");
  const [joinOtpError, setJoinOtpError] = useState("");
  const [joinOtpSent, setJoinOtpSent] = useState(false);
  const [joinSendingOtp, setJoinSendingOtp] = useState(false);
  const [joinVerifyingOtp, setJoinVerifyingOtp] = useState(false);
  const [joinTimer, setJoinTimer] = useState(60);
  const [canResendJoinOtp, setCanResendJoinOtp] = useState(false);
  const [joinSuccessMsg, setJoinSuccessMsg] = useState("");
  const [joinOtpVerified, setJoinOtpVerified] = useState(false);
  const [vendorId, setVendorId] = useState(null);
  const [joinName, setJoinName] = useState("");
  const [joinEmail, setJoinEmail] = useState("");
  const [joinAddress, setJoinAddress] = useState("");
  const [joinNameError, setJoinNameError] = useState("");
  const [joinEmailError, setJoinEmailError] = useState("");
  const [joinAddressError, setJoinAddressError] = useState("");
  const [joinUpdatingDetails, setJoinUpdatingDetails] = useState(false);
  const joinOtpInputRefs = useRef([]);

  const isPhoneValid = /^[6-9]\d{9}$/.test(joinPhone.trim());
  const isOtpFieldEnabled = isPhoneValid;

  const handlePhoneInputChange = (e) => {
    if (joinOtpVerified) return;
    const val = e.target.value.replace(/\D/g, "").slice(0, 10);
    setJoinPhone(val);
    setJoinPhoneError("");
    setJoinOtpError("");
    setJoinSuccessMsg("");

    if (val.length === 10) {
      if (/^[6-9]\d{9}$/.test(val)) {
        sendJoinOtpRequest(val);
      } else {
        setJoinPhoneError("Mobile number should start with 6, 7, 8, or 9");
      }
    } else {
      if (joinOtpSent) {
        setJoinOtpSent(false);
        setJoinOtp(["", "", "", "", "", ""]);
      }
    }
  };

  const sendJoinOtpRequest = async (phoneToSend) => {
    const mobile = phoneToSend || joinPhone.trim();
    if (!/^[6-9]\d{9}$/.test(mobile)) {
      setJoinPhoneError("Please enter a valid 10-digit mobile number");
      return;
    }
    setJoinPhoneError("");
    setJoinOtpError("");
    setJoinSendingOtp(true);
    try {
      const response = await fetch(BASE_URL_TEST + urls("becomeVendorSendOtp"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: apptoken ? `Bearer ${apptoken}` : "",
        },
        body: JSON.stringify({
          mobile_number: mobile,
        }),
      });
      const data = await response.json();
      setJoinSendingOtp(false);
      if (data && (data.status === true || data.status === "true")) {
        setJoinOtpSent(true);
        setJoinTimer(60);
        setCanResendJoinOtp(false);
        const otpFromResponse = data?.data?.otp || data?.otp;
        if (otpFromResponse && String(otpFromResponse).length === 6) {
          setJoinOtp(String(otpFromResponse).split(""));
        }
        setTimeout(() => {
          if (joinOtpInputRefs.current[0]) {
            joinOtpInputRefs.current[0].focus();
          }
        }, 150);
      } else {
        setJoinPhoneError(data?.message || "Failed to send OTP. Please try again.");
      }
    } catch (err) {
      setJoinSendingOtp(false);
      setJoinPhoneError("Network error. Please try again.");
    }
  };

  const handleJoinOtpChange = (e, index) => {
    const val = e.target.value.replace(/\D/g, "");
    if (!val) {
      const newOtp = [...joinOtp];
      newOtp[index] = "";
      setJoinOtp(newOtp);
      return;
    }

    if (val.length > 1) {
      const digits = val.slice(0, 6).split("");
      const newOtp = [...joinOtp];
      digits.forEach((d, i) => {
        if (i < 6) newOtp[i] = d;
      });
      setJoinOtp(newOtp);
      const nextIndex = Math.min(digits.length, 5);
      if (joinOtpInputRefs.current[nextIndex]) {
        joinOtpInputRefs.current[nextIndex].focus();
      }
      return;
    }

    const newOtp = [...joinOtp];
    newOtp[index] = val;
    setJoinOtp(newOtp);
    setJoinOtpError("");

    if (val && index < 5 && joinOtpInputRefs.current[index + 1]) {
      joinOtpInputRefs.current[index + 1].focus();
    }
  };

  const handleJoinOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !joinOtp[index] && index > 0) {
      if (joinOtpInputRefs.current[index - 1]) {
        joinOtpInputRefs.current[index - 1].focus();
      }
    }
  };

  const handleResendJoinOtp = () => {
    setJoinOtp(["", "", "", "", "", ""]);
    setJoinOtpError("");
    setCanResendJoinOtp(false);
    sendJoinOtpRequest(joinPhone);
  };

  const handleVerifyJoinOtp = async () => {
    const enteredOtp = joinOtp.join("").trim();
    if (!/^[6-9]\d{9}$/.test(joinPhone.trim())) {
      setJoinPhoneError("Please enter a valid 10-digit mobile number");
      return;
    }
    if (enteredOtp.length !== 6) {
      setJoinOtpError("Please enter the complete 6-digit OTP");
      return;
    }
    setJoinOtpError("");
    setJoinVerifyingOtp(true);
    try {
      const response = await fetch(BASE_URL_TEST + urls("becomeVendorVerifyOtp"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: apptoken ? `Bearer ${apptoken}` : "",
        },
        body: JSON.stringify({
          mobile_number: joinPhone.trim(),
          otp: enteredOtp,
        }),
      });
      const data = await response.json();
      setJoinVerifyingOtp(false);
      if (data && (data.status === true || data.status === "true")) {
        const vendorObj = data?.data || data;
        const vId = vendorObj?.id || data?.id;
        if (vId) {
          setVendorId(vId);
        }
        if (vendorObj?.name) setJoinName(vendorObj.name);
        if (vendorObj?.email) setJoinEmail(vendorObj.email);
        if (vendorObj?.address) setJoinAddress(vendorObj.address);

        setJoinOtpVerified(true);
        setJoinSuccessMsg("OTP verified successfully! Please enter your details below.");
        dispatch(getCustomerId(vId));
        dispatch(getUserLoginNumber({ mobile_number: joinPhone.trim() }));
      } else {
        setJoinOtpError(data?.message || "Invalid OTP. Please try again.");
      }
    } catch (err) {
      setJoinVerifyingOtp(false);
      setJoinOtpError("Verification failed. Please try again.");
    }
  };

  const handleUpdateVendorDetails = async () => {
    let hasError = false;
    if (!joinName.trim()) {
      setJoinNameError("Name is required");
      hasError = true;
    } else {
      setJoinNameError("");
    }

    if (!joinEmail.trim()) {
      setJoinEmailError("Email is required");
      hasError = true;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(joinEmail.trim())) {
      setJoinEmailError("Please enter a valid email address");
      hasError = true;
    } else {
      setJoinEmailError("");
    }

    if (!joinAddress.trim()) {
      setJoinAddressError("Address is required");
      hasError = true;
    } else {
      setJoinAddressError("");
    }

    if (hasError) return;

    setJoinUpdatingDetails(true);
    setJoinSuccessMsg("");
    try {
      const targetId = vendorId || 1;
      const response = await fetch(BASE_URL_TEST + urls("becomeVendorUpdate", targetId), {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: apptoken ? `Bearer ${apptoken}` : "",
        },
        body: JSON.stringify({
          name: joinName.trim(),
          email: joinEmail.trim(),
          address: joinAddress.trim(),
        }),
      });
      const data = await response.json();
      setJoinUpdatingDetails(false);
      if (data && (data.status === true || data.status === "true")) {
        setJoinSuccessMsg(data?.message || "Vendor details updated successfully!");
        setTimeout(() => {
          handleCloseJoinUs();
        }, 1500);
      } else {
        setJoinNameError(data?.message || "Failed to update vendor details. Please try again.");
      }
    } catch (err) {
      setJoinUpdatingDetails(false);
      setJoinNameError("Network error. Please try again.");
    }
  };

  const handleCloseJoinUs = () => {
    setIsJoinUsOpen(false);
    setJoinPhone("");
    setJoinOtp(["", "", "", "", "", ""]);
    setJoinPhoneError("");
    setJoinOtpError("");
    setJoinOtpSent(false);
    setJoinSendingOtp(false);
    setJoinVerifyingOtp(false);
    setJoinSuccessMsg("");
    setJoinTimer(60);
    setCanResendJoinOtp(false);
    setJoinOtpVerified(false);
    setVendorId(null);
    setJoinName("");
    setJoinEmail("");
    setJoinAddress("");
    setJoinNameError("");
    setJoinEmailError("");
    setJoinAddressError("");
    setJoinUpdatingDetails(false);
  };

  useEffect(() => {
    if (joinOtpSent && !joinOtpVerified && joinTimer > 0) {
      const countdown = setTimeout(() => setJoinTimer((prev) => prev - 1), 1000);
      return () => clearTimeout(countdown);
    } else if (joinTimer === 0) {
      setCanResendJoinOtp(true);
    }
  }, [joinOtpSent, joinOtpVerified, joinTimer]);
  const {
    data: tokenData,
    error: tokenError,
    fetchData: TokenFetchData,
  } = useFetch(BASE_URL_TEST + urls("generateToken"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });

  console.log("cartData in header", cartData);
  useEffect(() => {
    TokenFetchData({
      grant_type: "password",
      username: "Admin",
      password: "QWRtaW5AITQzMQ==",
    });
  }, []);

  useEffect(() => {
    if (tokenError) {
    } else if (tokenData && tokenData["status"] === true) {
      dispatch(getAppToken(tokenData["token"]));
    }
  }, [tokenData, tokenError]);

  const useGoogleMaps = () => {
    const { isLoaded, loadError } = useLoadScript({
      googleMapsApiKey: "AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8",
      libraries,
    });
    return { isLoaded, loadError };
  };

  const { isLoaded, loadError } = useGoogleMaps();

  const getFormattedAddress = async (lat, lng) => {
    try {
      const apiKey = "AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8";
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`,
      );
      const data = await response.json();
      if (data.status === "OK") {
        const address = data.results[0].formatted_address;
        if (changedAddress === null) {
          setFormattedAddress(address);
        }
        // Dispatch location
        dispatch(getLocation(lat, lng, address));
      } else {
        console.error("Error fetching address:", data.status);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    const getLocationFromGeolocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            setLatitude(latitude);
            setLongitude(longitude);
            setMapCenter({ lat: latitude, lng: longitude });
            if (formattedAddress == null) {
              getFormattedAddress(latitude, longitude);
            }
          },
          (error) => {
            if (
              error.code === error.PERMISSION_DENIED &&
              formattedAddress == null
            ) {
              setError(
                "Location access denied. Please allow location access in your browser settings.",
              );
              setIsModalOpen(true);
            } else if (error.code === error.POSITION_UNAVAILABLE) {
            } else if (error.code === error.TIMEOUT) {
              setError("Location request timed out.");
            } else {
              setError("An unknown error occurred.");
            }
            console.error("Error getting location:", error.message);
          },
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0,
          },
        );
      } else {
        console.log("Geolocation is not supported by this browser.");
        setError("Geolocation is not supported by your browser.");
      }
    };

    getLocationFromGeolocation();
  }, []);

  // Handle the location change modal close action
  const handleLocationChange = () => {
    // Here you could show a manual location change input or modal
    // For example, showing a modal where the user can enter a location manually
    setIsModalOpen(false); // Close the modal
    console.log("User can change location manually");
  };

  useEffect(() => {
    if (typeof window !== "undefined" && isLoaded && window.google) {
      autocompleteService.current =
        new window.google.maps.places.AutocompleteService();
    }
  }, [isLoaded]);

  useEffect(() => {
    if (isLoaded && window.google) {
      sessionToken.current =
        new window.google.maps.places.AutocompleteSessionToken();
    }
  }, [isLoaded]);

  const createRedIcon = () => {
    if (typeof window !== "undefined" && window.google && window.google.maps) {
      return {
        url: "https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png",
        scaledSize: new window.google.maps.Size(40, 40),
      };
    }
    console.log("Google Maps not loaded yet");
    return null;
  };

  const LocationPicker = ({ setLatitude, setLongitude, setLocation }) => {
    const handleMapClick = (e) => {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results[0]) {
          const address = results[0].formatted_address;
          setLatitude(lat);
          setLongitude(lng);
        }
      });
    };
  };
  useEffect(() => {
    if (window.google && window.google.maps && window.google.maps.places) {
      const input = document.getElementById("autocomplete");
      const autocomplete = new window.google.maps.places.Autocomplete(input, {
        types: ["geocode"],
        componentRestrictions: { country: "IN" },
      });
      autocompleteRef.current = autocomplete;
      autocomplete.addListener("place_changed", onPlaceChanged);
    }
  }, [isLoaded]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    // setSearchLocation(value);
    if (errors.location) {
      setErrors((prev) => ({ ...prev, location: "" }));
    }
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    debounceTimer.current = setTimeout(() => {
      if (value.length >= 1 && autocompleteService.current) {
        getPlacePredictions(value);
      } else {
        setSuggestions([]);
      }
    }, 500);
  };

  const onPlaceChanged = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();

      if (place && place.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        const formattedAddress = place.formatted_address || "Unknown Location";
        setFormattedAddress(formattedAddress);
        setLatitude(lat);
        setLongitude(lng);

        if (mapRef.current) {
          mapRef.current.panTo({ lat, lng });
          mapRef.current.setZoom(15);
        }
        if (markerRef.current) {
          markerRef.current.setPosition({ lat, lng });
        }
      } else {
        console.log("No geometry found for the selected place.");
      }
    }
  };

  const toggleDrawer = (open) => () => {
    setIsDrawerOpen(open);
  };

  const navigate = useNavigate();

  const handleLogin = () => {
    if (isLoggedIn) {
      handleCloseMenu();
      setIsLoggedIn(false);
    } else {
      navigate("/login");
    }
  };
  const handleVendorseller = () => {
    navigate("/vendorseller");
  };
  const handleAccount = () => {
    navigate("/profileinfo");
  };
  const handleCloseMenu = () => {
    setIsMenuOpen(false);
  };

  const handleSearchLocation = () => {
    if (geocoderRef.current && searchInput) {
      geocoderRef.current.geocode(
        { address: searchInput },
        (results, status) => {
          if (status === "OK" && results[0]) {
            const location = results[0].geometry.location;
            setLatitude(location.lat().toString());
            setLongitude(location.lng().toString());
            setFormattedAddress(results[0].formatted_address);
            if (mapRef.current) {
              mapRef.current.panTo({
                lat: location.lat(),
                lng: location.lng(),
              });
              mapRef.current.setZoom(15);
            }
          }
        },
      );
    }
  };

  const getPlacePredictions = (input) => {
    const query = input.trim();

    // First, fetch suggestions for India
    autocompleteService.current.getPlacePredictions(
      {
        input: query,
        sessionToken: sessionToken.current,
        componentRestrictions: { country: "IN" },
        types: ["geocode"],
      },
      (predictionsIndia, statusIndia) => {
        if (
          statusIndia === window.google.maps.places.PlacesServiceStatus.OK &&
          predictionsIndia
        ) {
          setSuggestions(predictionsIndia);
          autocompleteService.current.getPlacePredictions(
            {
              input: query,
              sessionToken: sessionToken.current,
              types: ["geocode"],
            },
            (predictionsGlobal, statusGlobal) => {
              if (
                statusGlobal ===
                  window.google.maps.places.PlacesServiceStatus.OK &&
                predictionsGlobal
              ) {
                const combinedSuggestions = [
                  ...predictionsIndia,
                  ...predictionsGlobal,
                ];
                setSuggestions(combinedSuggestions);
              } else {
                setSuggestions(predictionsIndia);
              }
            },
          );
        } else {
          autocompleteService.current.getPlacePredictions(
            {
              input: query,
              sessionToken: sessionToken.current,
              types: ["geocode"],
            },
            (predictionsGlobal, statusGlobal) => {
              if (
                statusGlobal ===
                  window.google.maps.places.PlacesServiceStatus.OK &&
                predictionsGlobal
              ) {
                setSuggestions(predictionsGlobal);
              } else {
                setSuggestions([]);
              }
            },
          );
        }
      },
    );
  };

  const handleSuggestionClick = (placeId) => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ placeId }, (results, status) => {
      if (status === "OK" && results[0]) {
        const location = results[0].geometry.location;
        const lat = location.lat();
        const lng = location.lng();
        const changedAddress = results[0].formatted_address;
        setLatitude(lat);
        setLongitude(lng);
        setSuggestions([]);
        setFormattedAddress(results[0].formatted_address);
        dispatch(getLocation(lat, lng, changedAddress));
        if (mapRef.current) {
          mapRef.current.panTo({ lat, lng });
          mapRef.current.setZoom(15);
        }
      }
    });
  };

  // Handle map click to place marker
  const handleMapClick = (event) => {
    const newLat = event.latLng.lat();
    const newLng = event.latLng.lng();

    setLatitude(newLat.toString());
    setLongitude(newLng.toString());

    // Get address from coordinates
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode(
      { location: { lat: newLat, lng: newLng } },
      (results, status) => {
        if (status === "OK" && results[0]) {
          const location = results[0].geometry.location;
          const lat = location.lat();
          const lng = location.lng();
          setLatitude(lat);
          setLongitude(lng);
          setSuggestions([]);
          setFormattedAddress(results[0].formatted_address);
          if (mapRef.current) {
            mapRef.current.panTo({ lat, lng });
            mapRef.current.setZoom(15);
          }
        }
      },
    );
  };

  // Handle marker drag end
  const handleMarkerDragEnd = (event) => {
    const newLat = event.latLng.lat();
    const newLng = event.latLng.lng();

    setLatitude(newLat.toString());
    setLongitude(newLng.toString());

    // Get address from coordinates
    if (geocoderRef.current) {
      geocoderRef.current.geocode(
        { location: { lat: newLat, lng: newLng } },
        (results, status) => {
          if (status === "OK" && results[0]) {
            setFormattedAddress(results[0].formatted_address);
            setSearchInput(results[0].formatted_address);
          }
        },
      );
    }
  };

  // Handle confirmation button click
  const handleConfirmLocation = () => {
    try {
      let validationErrors = {};

      if (!latitude || !longitude || !formattedAddress) {
        validationErrors.location = "Please select location";
        setErrors(validationErrors);
        return;
      }

      const locationData = {
        latitude,
        longitude,
        formattedAddress,
      };

      setFormattedAddress(formattedAddress);

      if (typeof onLocationConfirm === "function") {
        onLocationConfirm(locationData);
      } else {
        console.log("Location confirmed:", locationData);
      }

      setIsModalOpen(false);
    } catch (error) {
      console.error("Error in handleConfirmLocation:", error);
      setIsModalOpen(false);
    }
  };

  const {
    data: searchData,
    isLoading: isSearchLoading,
    error: searchError,
    fetchData: fetchSearchData,
  } = useFetch(
    BASE_URL_TEST + `/api/main/search?query=${encodeURIComponent(query)}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: apptoken ? `Bearer ${apptoken}` : "",
      },
    },
  );

  useEffect(() => {
    if (query) {
      fetchSearchData();
    }
  }, [query]);

  const handleQueryChange = (e) => {
    const value = e.target.value;
    setQuery(value);

    if (debounceTimer.current) clearTimeout(debounceTimer.current);

    debounceTimer.current = setTimeout(() => {
      if (value.length > 1) {
        fetchSearchData(value);
        setOpenDropdown(true);
      } else {
        setSearchSuggestions([]);
        setOpenDropdown(false);
      }
    }, 400);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpenDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (searchData && searchData["status"] == true) {
      const vendorSuggestions = (searchData?.vendors || []).map((v) => ({
        id: v?.id,
        type: "vendor",
        label: v?.name,
        profile: v?.profile,
        vendorId: v?.vendor_id,
        userType: v?.reg_list_type,
      }));

      const productSuggestions = (searchData?.products || []).map((p) => ({
        id: p?.product_id,
        vendorId: p?.vendorid,
        type: "product",
        label: p?.product_name,
        vendorName: p?.vendor_name,
        userType: p?.reg_list_type,
      }));

      const storeSuggestions = (searchData?.vendors || []).map((s) => ({
        id: s?.id,
        type: "store",
        label: s?.name,
        profile: s?.profile,
        vendorId: s?.vendor_id,
        userType: s?.reg_list_type,
      }));

      setSearchSuggestions([
        ...vendorSuggestions,
        ...productSuggestions,
        ...storeSuggestions,
      ]);
      setOpenDropdown(true);
    } else {
      setSearchSuggestions([]);
      setOpenDropdown(false);
    }
  }, [searchData]);

  const handleSearchSuggestionClick = async (s) => {
    setQuery(s.label);
    setOpenDropdown(false);

    if (s.type === "vendor") {
      let formattedVendor = {};

      try {
        const response = await fetch(
          `${BASE_URL_TEST}/api/vendor/findById/${s.id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${apptoken}`,
            },
          },
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const vendor = await response.json();
        const vendorData = vendor.data;
        // Format vendor data
        formattedVendor = {
          id: vendorData.id,
          name: vendorData.name,
          shopName: vendorData.shop_name,
          location: vendorData.location || vendorData.city,
          city: vendorData.city,
          listing: vendorData.listing,
          listingName: vendorData.listing?.name,
          category: vendorData.listing?.name,
          description:
            Array.isArray(vendorData.categories) &&
            vendorData.categories.length > 0
              ? vendorData.categories.map((c) => c.description).join(", ")
              : Array.isArray(vendorData.listCategories) &&
                  vendorData.listCategories.length > 0
                ? vendorData.listCategories.map((c) => c.description).join(", ")
                : "",
          image: vendorData.store_image,
          distance: vendorData.distance
            ? `${vendorData.distance} kms near to your Location`
            : "N/A",
          rating: "4.8" || "N/A",
          address: `${vendorData.street}, ${vendorData.city}, ${vendorData.state}, ${vendorData.country}, ${vendorData.pincode}`,
          openTime: vendorData.open_time,
          closeTime: vendorData.close_time,
          latitude: vendorData.latitude,
          longitude: vendorData.longitude,
          phoneNumber: vendorData.phone_number,
          regularListType: vendorData.reg_list_type,
        };

        // Navigate to vendor's shop page with state
        console.log("formattedVendor", formattedVendor);
        if (s.userType === "regular") {
          navigate(buildShopPath(formattedVendor), { state: { shop: formattedVendor } });
        } else if (s.userType === "listing") {
          navigate(buildListingShopPath(formattedVendor), {
            state: { shop: formattedVendor },
          });
        }
      } catch (error) {
        console.error("Error fetching vendor:", error);
      }
    } else if (s.type === "product") {
      let formattedVendor = {};
      try {
        const response = await fetch(
          `${BASE_URL_TEST}/api/vendor/findById/${s.vendorId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${apptoken}`,
            },
          },
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const vendor = await response.json();
        const vendorData = vendor.data;
        // Format vendor data
        formattedVendor = {
          id: vendorData.id,
          name: vendorData.name,
          shopName: vendorData.shop_name,
          location: vendorData.location || vendorData.city,
          city: vendorData.city,
          listing: vendorData.listing,
          listingName: vendorData.listing?.name,
          category: vendorData.listing?.name,
          description:
            Array.isArray(vendorData.categories) &&
            vendorData.categories.length > 0
              ? vendorData.categories.map((c) => c.description).join(", ")
              : Array.isArray(vendorData.listCategories) &&
                  vendorData.listCategories.length > 0
                ? vendorData.listCategories.map((c) => c.description).join(", ")
                : "",
          image: vendorData.store_image,
          distance: vendorData.distance
            ? `${vendorData.distance} kms near to your Location`
            : "N/A",
          rating: "4.8" || "N/A",
          address: `${vendorData.street}, ${vendorData.city}, ${vendorData.state}, ${vendorData.country}, ${vendorData.pincode}`,
          openTime: vendorData.open_time,
          closeTime: vendorData.close_time,
          latitude: vendorData.latitude,
          longitude: vendorData.longitude,
          phoneNumber: vendorData.phone_number,
          regularListType: vendorData.reg_list_type,
        };

        // Navigate to vendor's shop page with state
        console.log("formattedVendorproduts", formattedVendor);
        if (s.userType === "regular") {
          navigate(buildShopPath(formattedVendor), { state: { shop: formattedVendor } });
        } else if (s.userType === "listing") {
          navigate(buildListingShopPath(formattedVendor), {
            state: { shop: formattedVendor },
          });
        }
      } catch (error) {
        console.error("Error fetching vendor:", error);
      }
    }
    // else if (s.type === "store") {
    //   let formattedVendor = {};

    //   try {
    //     const response = await fetch(
    //       `${BASE_URL_TEST}/api/vendor/findById/${s.vendorId}`,
    //       {
    //         method: "GET",
    //         headers: {
    //           "Content-Type": "application/json",
    //           Authorization: `Bearer ${apptoken}`,
    //         },
    //       },
    //     );

    //     if (!response?.ok) {
    //       throw new Error(`HTTP error! status: ${response?.status}`);
    //     }

    //     const vendor = await response.json();
    //     const vendorData = vendor?.data || {};

    //     formattedVendor = {
    //       id: vendorData?.id,
    //       name: vendorData?.name,
    //       shopName: vendorData?.shop_name,
    //       description:
    //         Array.isArray(vendorData?.categories) &&
    //         vendorData?.categories?.length > 0
    //           ? vendorData.categories.map((c) => c?.description).join(", ")
    //           : Array.isArray(vendorData?.listCategories) &&
    //               vendorData?.listCategories?.length > 0
    //             ? vendorData.listCategories
    //                 .map((c) => c?.description)
    //                 .join(", ")
    //             : "",
    //       image: vendorData?.store_image,
    //       distance: vendorData?.distance
    //         ? `${vendorData.distance} kms near to your Location`
    //         : "N/A",
    //       rating: "4.8",
    //       address: `${vendorData?.street || ""}, ${vendorData?.city || ""}, ${vendorData?.state || ""}, ${vendorData?.country || ""}, ${vendorData?.pincode || ""}`,
    //       openTime: vendorData?.open_time,
    //       closeTime: vendorData?.close_time,
    //       latitude: vendorData?.latitude,
    //       longitude: vendorData?.longitude,
    //       phoneNumber: vendorData?.phone_number,
    //       regularListType: vendorData?.reg_list_type,
    //     };

    //     if (s?.userType === "regular") {
    //       navigate(`/shop/${s?.vendorId}`, {
    //         state: { shop: formattedVendor },
    //       });
    //     } else if (s?.userType === "listing") {
    //       navigate(buildListingShopPath({ id: s?.vendorId }), {
    //         state: { shop: formattedVendor },
    //       });
    //     }
    //   } catch (error) {
    //     console.error("Error fetching store:", error);
    //   }
    // }
  };

  const DrawerContent = () => (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          toggleDrawer(false);
        }
      }}
    >
      <List>
        <ListItem>
          <InputBase
            placeholder="Search for Stores, Products..."
            sx={{
              flexGrow: 1,
              fontSize: "1rem",
              backgroundColor: "#f8f9fa",
              borderRadius: 2,
              paddingX: 2,
              paddingY: 1,
              width: "100%",
              border: "1px solid #e0e0e0",
            }}
            value={query}
            onChange={handleQueryChange}
            onFocus={() => query.length > 1 && setOpenDropdown(true)}
          />
          <IconButton
            onClick={() => {
              if (query.length > 1) {
                fetchSearchData(query)
                  .then((data) => {
                    setSearchSuggestions(data);
                    setOpenDropdown(true);
                  })
                  .catch(() => {
                    setSearchSuggestions([]);
                    setOpenDropdown(false);
                  });
              }
            }}
            sx={{
              position: "absolute",
              right: 0,
              top: "50%",
              transform: "translateY(-50%)",
            }}
            aria-label="search"
          ></IconButton>

          {openDropdown && (
            <Box
              sx={{
                position: "absolute",
                top: "110%",
                left: 0,
                width: "100%",
                backgroundColor: "#fff",
                borderRadius: 3,
                boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
                zIndex: 1200,
                maxHeight: 350,
                overflowY: "auto",
              }}
            >
              {/* Loader */}
              {loading && (
                <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                  <CircularProgress size={25} />
                </Box>
              )}

              {!loading && searchSuggestions?.length === 0 && (
                <Box
                  sx={{ textAlign: "center", py: 3, color: "text.secondary" }}
                >
                  No results found
                </Box>
              )}

              {/* VENDORS */}
              {!loading &&
                searchSuggestions?.filter((s) => s?.type === "vendor")?.length >
                  0 && (
                  <>
                    <Typography
                      sx={{
                        px: 2,
                        pt: 1,
                        pb: 0.5,
                        fontSize: 13,
                        fontWeight: 600,
                        color: "#888",
                      }}
                    >
                      VENDORS
                    </Typography>

                    {searchSuggestions
                      ?.filter((s) => s?.type === "vendor")
                      ?.map((s) => (
                        <Box
                          key={s?.id}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                            px: 2,
                            py: 1,
                            cursor: "pointer",
                            "&:hover": { backgroundColor: "#f5f5f5" },
                          }}
                          onClick={() => handleSearchSuggestionClick(s)}
                        >
                          {s?.profile ? (
                            <img
                              src={s.profile}
                              alt={s.label}
                              style={{
                                width: 32,
                                height: 32,
                                borderRadius: "50%",
                              }}
                            />
                          ) : (
                            <StoreIcon color="primary" />
                          )}

                          <Typography fontSize="0.9rem">{s?.label}</Typography>
                        </Box>
                      ))}
                  </>
                )}

              {/* PRODUCTS */}
              {!loading &&
                searchSuggestions?.filter((s) => s?.type === "product")
                  ?.length > 0 && (
                  <>
                    <Typography
                      sx={{
                        px: 2,
                        pt: 1,
                        pb: 0.5,
                        fontSize: 13,
                        fontWeight: 600,
                        color: "#888",
                      }}
                    >
                      PRODUCTS
                    </Typography>

                    {searchSuggestions
                      ?.filter((s) => s?.type === "product")
                      ?.map((s) => (
                        <Box
                          key={s?.id}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                            px: 2,
                            py: 1,
                            cursor: "pointer",
                            "&:hover": { backgroundColor: "#f5f5f5" },
                          }}
                          onClick={() => handleSearchSuggestionClick(s)}
                        >
                          <ShoppingBagIcon sx={{ color: "#ff9800" }} />

                          <Typography fontSize="0.9rem">{s?.label}</Typography>
                        </Box>
                      ))}
                  </>
                )}
              {/* STORES */}
              {/* {!loading &&
                searchSuggestions?.filter((s) => s?.type === "store")?.length >
                  0 && (
                  <>
                    <Typography
                      sx={{
                        px: 2,
                        pt: 1,
                        pb: 0.5,
                        fontSize: 13,
                        fontWeight: 600,
                        color: "#888",
                      }}
                    >
                      STORES
                    </Typography>

                    {searchSuggestions
                      ?.filter((s) => s?.type === "store")
                      ?.map((s) => (
                        <Box
                          key={s?.id}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                            px: 2,
                            py: 1,
                            cursor: "pointer",
                            "&:hover": { backgroundColor: "#f5f5f5" },
                          }}
                          onClick={() => handleSearchSuggestionClick(s)}
                        >
                          <ShoppingBagIcon sx={{ color: "#ff9800" }} />

                          <Typography fontSize="0.9rem">{s?.label}</Typography>
                        </Box>
                      ))}
                  </>
                )} */}
            </Box>
          )}
        </ListItem>
        <Divider />
        <ListItemButton onClick={() => navigate("/")}>
          <ListItemIcon>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText primary="Home" />
        </ListItemButton>
        <ListItemButton onClick={() => navigate("/cart")}>
          <ListItemIcon>
            <ShoppingCartIcon />
          </ListItemIcon>
          <ListItemText primary="Cart" />
        </ListItemButton>
        <ListItemButton>
          <ListItemIcon>
            <PersonIcon />
          </ListItemIcon>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              cursor: "pointer",
            }}
          >
            {/* <Typography
              variant="body1"
              sx={{
                color: "orange",
                fontWeight: "bold",
                cursor: "pointer",
                textDecoration: "none",
              }}
              onClick={handleLogin}
            >
              {isLoggedIn ? "Logout" : "Login"}{" "}
            </Typography> */}

            {!customerId && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  cursor: "pointer",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: "orange",
                    fontWeight: "bold",
                    cursor: "pointer",
                    textDecoration: "none",
                  }}
                  onClick={handleLogin}
                >
                  Login
                </Typography>
              </Box>
            )}

            {customerId && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  cursor: "pointer",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: "orange",
                    fontWeight: "bold",
                    cursor: "pointer",
                    textDecoration: "none",
                  }}
                  onClick={handleAccount}
                >
                  Account
                </Typography>
              </Box>
            )}
            {/* <KeyboardArrowDownIcon sx={{ color: "orange", fontSize: 20 }} /> */}
          </Box>
        </ListItemButton>
      </List>
      <Divider />
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, p: 2 }}>
        <Button
          variant="contained"
          onClick={() => {
            setIsDrawerOpen(false);
            setIsJoinUsOpen(true);
          }}
          sx={{
            backgroundColor: "#e53935",
            color: "#ffffff",
            fontWeight: "bold",
            fontSize: 12,
            width: "100%",
            borderRadius: "8px",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#d32f2f",
            },
          }}
        >
          Join Us
        </Button>
        <Button
          variant="outlined"
          onClick={handleVendorseller}
          sx={{
            borderColor: "red",
            color: "red",
            fontWeight: "bold",
            fontSize: 12,
            width: "100%",
            borderRadius: "8px",
            textTransform: "none",
            "&:hover": {
              borderColor: "red",
              backgroundColor: "#fff8e5",
            },
          }}
        >
          Become a Vendor or Seller
        </Button>
      </Box>
    </Box>
  );

  const handleCart1 = async () => {
    setLoading(true); // show loader
    console.time("handleCart");

    if (cartData && cartData?.items?.length > 0) {
      navigate("/cart");
    } else {
      dispatch(
        setModalProperties({
          showModal: true,
          modalMessage: "No Items in Cart",
        }),
      );
    }

    setTimeout(() => {
      setLoading(false);
    }, 4000);
  };

  const handleCart = async () => {
    // If cart is empty
    if (!cartData?.items || cartData.items.length === 0) {
      dispatch(
        setModalProperties({
          showModal: true,
          modalMessage: "No Items in Cart",
        }),
      );
      return;
    }

    setLoading(true);
    navigate("/cart");
    setTimeout(() => {
      setLoading(false);
    }, 4000);
  };

  return (
    <>
      <Slide in={showHeader} direction="down">
        <AppBar
          position="sticky"
          color="inherit"
          elevation={3}
          sx={{
            paddingY: isSmallScreen ? 0.5 : 1,
            paddingX: isSmallScreen ? 1 : 4,
            backgroundColor: "#ffffff",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            width: "100%",
            maxWidth: "100vw",
            height: "auto",
            overflowX: "hidden",
            boxSizing: "border-box",
          }}
        >
          <Toolbar
            sx={{
              display: "flex",
              justifyContent: isSmallScreen ? "space-between" : "stretch",
              alignItems: "center",
              flexDirection: "column",
              gap: isSmallScreen ? 0 : 2,
              width: "100%",
              maxWidth: "100%",
              padding: isSmallScreen ? "8px 0" : "16px 0",
              minHeight: "auto !important",
            }}
          >
            {isSmallScreen ? (
              <>
                {/* Mobile Navbar - First Row */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    maxWidth: "100%",
                    gap: 1,
                  }}
                >
                  <IconButton onClick={toggleDrawer(true)} size="small">
                    <MenuIcon />
                  </IconButton>

                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "bold",
                      color: "red",
                      fontSize: "16px",
                      flexGrow: 1,
                      textAlign: "center",
                    }}
                  >
                    Sthanick
                  </Typography>

                  <IconButton onClick={handleCart} size="small">
                    <Badge
                      badgeContent={cartData ? cartData?.items.length : 0}
                      color="secondary"
                      sx={{
                        "& .MuiBadge-badge": {
                          backgroundColor:
                            cartData?.items.length === 0 ? "white" : "green",
                          color:
                            cartData?.items.length === 0 ? "black" : "white",
                        },
                      }}
                    >
                      {loading ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        <ShoppingCartIcon />
                      )}
                    </Badge>
                  </IconButton>
                </Box>

                {/* Mobile Navbar - Second Row: Location */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    width: "100%",
                    maxWidth: "100%",
                    gap: 0.5,
                    mt: 1,
                  }}
                >
                  <IconButton
                    onClick={() => setIsModalOpen(true)}
                    size="small"
                    sx={{ padding: 0.5, mt: -0.5 }}
                  >
                    <RoomIcon sx={{ color: "red", fontSize: 20 }} />
                  </IconButton>
                  <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "10px",
                        color: "red",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                        whiteSpace: "normal",
                        lineHeight: 1.3,
                      }}
                    >
                      {formattedAddress || "Select your location"}
                    </Typography>
                  </Box>
                  <Link
                    href="#"
                    onClick={() => setIsModalOpen(true)}
                    sx={{
                      color: "#4169E1",
                      fontWeight: "bold",
                      fontSize: 8,
                      textDecoration: "none",
                      whiteSpace: "nowrap",
                      mt: 0.2,
                    }}
                  >
                    Change
                  </Link>
                </Box>

                {/* Mobile Navbar - Third Row: Search */}
                <Box
                  ref={containerRef}
                  sx={{
                    width: "100%",
                    maxWidth: "100%",
                    mt: 1,
                    position: "relative",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "#f8f9fa",
                      borderRadius: 2,
                      paddingX: 1.5,
                      paddingY: 0.5,
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    <SearchIcon
                      sx={{ color: "#757575", fontSize: 20, mr: 0.5 }}
                    />
                    <InputBase
                      placeholder="Search for Stores, Products..."
                      sx={{
                        flexGrow: 1,
                        fontSize: "0.85rem",
                      }}
                      value={query}
                      onChange={handleQueryChange}
                      onFocus={() => query.length > 1 && setOpenDropdown(true)}
                    />
                  </Box>

                  {openDropdown && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        width: "100%",
                        backgroundColor: "white",
                        border: "1px solid #ddd",
                        borderRadius: 2,
                        boxShadow: 2,
                        zIndex: 1200,
                        maxHeight: 300,
                        overflowY: "auto",
                      }}
                    >
                      {searchSuggestions.length > 0 ? (
                        searchSuggestions.map((s) => (
                          <Box
                            key={`${s.type}-${s.id}`}
                            sx={{
                              px: 2,
                              py: 1,
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              "&:hover": { bgcolor: "#f5f5f5" },
                            }}
                            onClick={() => handleSearchSuggestionClick(s)}
                          >
                            {s.type === "vendor" && s.profile ? (
                              <>
                                <img
                                  src={s.profile}
                                  alt={s.label}
                                  style={{
                                    width: 30,
                                    height: 30,
                                    borderRadius: "50%",
                                    marginRight: 10,
                                  }}
                                />
                                <span>{s.label}</span>
                              </>
                            ) : (
                              <span>{s.label}</span>
                            )}
                          </Box>
                        ))
                      ) : (
                        <Box
                          sx={{
                            px: 2,
                            py: 1,
                            color: "red",
                            textAlign: "center",
                            fontWeight: "bold",
                            fontSize: "1.25rem",
                          }}
                        >
                          No results found
                        </Box>
                      )}
                    </Box>
                  )}
                </Box>

                {/* Mobile Navbar - Fourth Row: Join Us & Become a Vendor Buttons - Hidden (Available in Menu) */}
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: "100%",
                    mt: 1,
                    mb: 0.5,
                    display: "none", // Hidden - button available in drawer menu
                    justifyContent: "flex-end",
                    gap: 1,
                    paddingRight: 1,
                  }}
                >
                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      textTransform: "none",
                      backgroundColor: "#e53935",
                      color: "white",
                      fontWeight: "bold",
                      fontSize: "0.65rem",
                      paddingY: 0.3,
                      paddingX: 1.5,
                      minWidth: "auto",
                      borderRadius: "6px",
                      "&:hover": {
                        backgroundColor: "#d32f2f",
                      },
                    }}
                    onClick={() => setIsJoinUsOpen(true)}
                  >
                    Join Us
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    sx={{
                      textTransform: "none",
                      borderColor: "red",
                      color: "red",
                      fontWeight: "bold",
                      fontSize: "0.65rem",
                      paddingY: 0.3,
                      paddingX: 1.5,
                      minWidth: "auto",
                      borderRadius: "6px",
                      "&:hover": {
                        borderColor: "red",
                        backgroundColor: "#fff8e5",
                      },
                    }}
                    onClick={handleVendorseller}
                  >
                    Become a Vendor
                  </Button>
                </Box>

                <Modal
                  open={isModalOpen}
                  onClose={() => setIsModalOpen(false)}
                  aria-labelledby="location-modal-title"
                >
                  <Paper
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: isSmallScreen ? "95%" : "80%",
                      maxWidth: "800px",
                      bgcolor: "background.paper",
                      boxShadow: 24,
                      p: isSmallScreen ? 2 : 4,
                      borderRadius: 2,
                      outline: "none",
                      maxHeight: "90vh",
                      overflow: "auto",
                    }}
                  >
                    <IconButton
                      onClick={() => setIsModalOpen(false)}
                      sx={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        color: "#9e9e9e",
                      }}
                    >
                      <CancelIcon />
                    </IconButton>

                    <Typography
                      id="location-modal-title"
                      sx={{
                        textAlign: "center",
                        fontWeight: "bold",
                        color: "black",
                        py: 1,
                        mb: 2,
                      }}
                    >
                      Location Information
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        flexWrap: "wrap",
                        gap: 2,
                      }}
                    >
                      <InputBase
                        placeholder="Enter location"
                        fullWidth
                        onChange={handleInputChange}
                        sx={{
                          fontSize: "1rem",
                          backgroundColor: "#f8f9fa",
                          borderRadius: 2,
                          paddingX: 2,
                          paddingY: 1,
                        }}
                        id="autocomplete"
                      />
                      <IconButton onClick={handleSearchLocation}>
                        <SearchIcon />
                      </IconButton>
                    </Box>

                    {errors?.location && (
                      <Typography sx={{ color: "red", fontSize: 16 }}>
                        {errors.location}
                      </Typography>
                    )}

                    {suggestions.length > 0 && (
                      <ul
                        style={{
                          position: "absolute",
                          top: "20%",
                          left: "10px",
                          backgroundColor: "white",
                          padding: "10px",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                          zIndex: 10,
                          listStyleType: "none",
                          maxHeight: "400px",
                          overflowY: "auto",
                          width: "50%",
                          borderRadius: "8px",
                        }}
                      >
                        {suggestions.map((place) => (
                          <li
                            key={place.place_id}
                            onClick={() =>
                              handleSuggestionClick(place.place_id)
                            }
                            style={{
                              padding: "12px",
                              cursor: "pointer",
                              borderBottom: "1px solid #ddd",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <PlaceIcon
                              style={{ marginRight: "12px", color: "#808080" }}
                            />
                            {place.description}
                          </li>
                        ))}
                      </ul>
                    )}
                    {isLoaded ? (
                      <Box sx={{ position: "relative" }}>
                        <GoogleMap
                          ref={mapRef}
                          onLoad={(map) => {
                            mapRef.current = map;
                            const defaultLoc = { lat: 17.7, lng: 83.3 };
                            if (!latitude || !longitude) {
                              map.panTo(defaultLoc);
                              setLatitude(defaultLoc.lat.toString());
                              setLongitude(defaultLoc.lng.toString());
                            } else {
                              map.panTo({
                                lat: parseFloat(latitude),
                                lng: parseFloat(longitude),
                              });
                            }
                            map.setZoom(15);
                          }}
                          center={{
                            lat: parseFloat(latitude) || 17.7,
                            lng: parseFloat(longitude) || 83.3,
                          }}
                          zoom={15}
                          mapContainerStyle={{
                            height: "60vh",
                            width: "100%",
                            borderRadius: "8px",
                          }}
                          options={{
                            streetViewControl: false,
                            mapTypeControl: false,
                            fullscreenControl: false,
                          }}
                          onClick={handleMapClick}
                        >
                          {latitude && longitude && (
                            <MarkerF
                              ref={markerRef}
                              position={{
                                lat: parseFloat(latitude),
                                lng: parseFloat(longitude),
                              }}
                              icon={createRedIcon()}
                              draggable
                              onDragEnd={handleMarkerDragEnd}
                              onClick={() => setInfoWindowOpen(true)}
                            >
                              {isInfoWindowOpen && (
                                <InfoWindowF
                                  position={{
                                    lat: parseFloat(latitude),
                                    lng: parseFloat(longitude),
                                  }}
                                  onCloseClick={() => setInfoWindowOpen(false)}
                                >
                                  <Box>
                                    <Typography variant="body2">
                                      <b>Latitude:</b> {latitude},{" "}
                                      <b>Longitude:</b> {longitude}
                                    </Typography>
                                    <Typography variant="body2">
                                      {formattedAddress}
                                    </Typography>
                                  </Box>
                                </InfoWindowF>
                              )}
                            </MarkerF>
                          )}
                        </GoogleMap>
                      </Box>
                    ) : (
                      <Typography>Loading map...</Typography>
                    )}

                    {/* Confirm Button */}
                    <Box
                      sx={{ display: "flex", justifyContent: "center", mt: 2 }}
                    >
                      <Button
                        variant="contained"
                        fullWidth
                        onClick={handleConfirmLocation}
                        sx={{
                          bgcolor: "#e91e63",
                          color: "white",
                          "&:hover": { bgcolor: "#c2185b" },
                          py: 1.5,
                          fontWeight: "bold",
                          borderRadius: 2,
                        }}
                      >
                        Confirm & Continue
                      </Button>
                    </Box>
                  </Paper>
                </Modal>
              </>
            ) : (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                    }}
                  >
                    <Box>
                      <Link
                        to="/"
                        style={{ textDecoration: "none", cursor: "pointer" }}
                      >
                        {/* <Box>
                          <Typography
                            component="h2"
                            variant="h6"
                            sx={{ fontSize: "1.5rem", fontWeight: "bold" }}
                          >
                            <span style={{ color: "#2986cc" }}>S</span>
                            <span style={{ color: "#f97300" }}>t</span>
                            <span style={{ color: "#4ea8de" }}>h</span>
                            <span style={{ color: "#2986cc" }}>a</span>
                            <span style={{ color: "#f97300" }}>n</span>
                            <span style={{ color: "#4ea8de" }}>i</span>
                            <span style={{ color: "#2986cc" }}>c</span>
                            <span style={{ color: "#f97300" }}>k</span>
                          </Typography>
                        </Box> */}
                        <Box
                          component="img"
                          src="/Sthanick.jpeg"
                          alt="Sthanick"
                          sx={{
                            height: 40,
                            width: "auto",
                          }}
                        />
                      </Link>
                    </Box>
                    <Box display="flex" alignItems="center" marginLeft={10}>
                      <IconButton onClick={() => setIsModalOpen(true)}>
                        <RoomIcon sx={{ color: "red", fontSize: 40 }} />
                      </IconButton>
                      <Modal
                        open={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                        aria-labelledby="location-modal-title"
                      >
                        <Paper
                          sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "80%",
                            maxWidth: "800px",
                            bgcolor: "background.paper",
                            boxShadow: 24,
                            p: 4,
                            borderRadius: 2,
                            outline: "none",
                            maxHeight: "90vh",
                            overflow: "auto",
                          }}
                        >
                          <IconButton
                            onClick={() => setIsModalOpen(false)}
                            sx={{
                              position: "absolute",
                              top: 10,
                              right: 10,
                              color: "#9e9e9e",
                            }}
                          >
                            <CancelIcon />
                          </IconButton>
                          <Typography
                            id="location-modal-title"
                            sx={{
                              textAlign: "center",
                              color: "black",
                              fontWeight: "bold",
                              py: 1,
                              borderRadius: 1,
                              mb: 2,
                            }}
                          >
                            Location Information
                          </Typography>

                          <Box
                            display="flex"
                            alignItems="center"
                            gap={1}
                            marginBottom={2}
                          >
                            <InputBase
                              placeholder="Enter location"
                              fullWidth
                              onChange={handleInputChange}
                              sx={{
                                fontSize: "1rem",
                                backgroundColor: "#f8f9fa",
                                borderRadius: 2,
                                paddingX: 2,
                                paddingY: 1,
                              }}
                              id="autocomplete"
                            />

                            {suggestions.length > 0 && (
                              <ul
                                style={{
                                  position: "absolute",
                                  top: "20%",
                                  left: "10px",
                                  backgroundColor: "white",
                                  padding: "10px",
                                  boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                                  zIndex: 10,
                                  listStyleType: "none",
                                  maxHeight: "400px",
                                  overflowY: "auto",
                                  width: "50%",
                                  borderRadius: "8px",
                                }}
                              >
                                {suggestions.map((place) => (
                                  <li
                                    key={place.place_id}
                                    onClick={() =>
                                      handleSuggestionClick(place.place_id)
                                    }
                                    style={{
                                      padding: "12px",
                                      cursor: "pointer",
                                      borderBottom: "1px solid #ddd",
                                      transition: "background-color 0.3s",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    onMouseEnter={(e) =>
                                      (e.target.style.backgroundColor =
                                        "#f0f0f0")
                                    }
                                    onMouseLeave={(e) =>
                                      (e.target.style.backgroundColor = "white")
                                    }
                                  >
                                    <PlaceIcon
                                      style={{
                                        marginRight: "12px",
                                        color: "#808080",
                                      }}
                                    />
                                    {place.description}
                                  </li>
                                ))}
                              </ul>
                            )}

                            <IconButton onClick={handleSearchLocation}>
                              <SearchIcon />
                            </IconButton>
                          </Box>
                          {errors.location && (
                            <Typography
                              sx={{
                                textAlign: "left",
                                color: "red",
                                fontSize: 16,
                              }}
                            >
                              {errors.location}
                            </Typography>
                          )}
                          {isLoaded ? (
                            <Box sx={{ position: "relative" }}>
                              <GoogleMap
                                ref={mapRef}
                                onLoad={(map) => {
                                  mapRef.current = map;
                                  // Default to a location if none is selected
                                  if (!latitude && !longitude) {
                                    const defaultLocation = {
                                      lat: 17.7,
                                      lng: 83.3,
                                    }; // Default to Visakhapatnam

                                    console.log(
                                      "lat lng",
                                      defaultLocation.lat.toString(),
                                      defaultLocation.lng.toString(),
                                    );
                                    map.panTo(defaultLocation);
                                    setLatitude(defaultLocation.lat.toString());
                                    setLongitude(
                                      defaultLocation.lng.toString(),
                                    );
                                  } else {
                                    map.panTo({
                                      lat: parseFloat(latitude),
                                      lng: parseFloat(longitude),
                                    });
                                  }
                                  map.setZoom(15);
                                }}
                                center={{
                                  lat: parseFloat(latitude) || 17.7,
                                  lng: parseFloat(longitude) || 83.3,
                                }}
                                zoom={15}
                                mapContainerStyle={{
                                  height: "60vh",
                                  width: "100%",
                                  borderRadius: "8px",
                                }}
                                options={{
                                  streetViewControl: false,
                                  mapTypeControl: false,
                                  fullscreenControl: false,
                                }}
                                onClick={handleMapClick}
                              >
                                {/* Marker Component */}
                                {latitude && longitude && (
                                  <MarkerF
                                    ref={markerRef}
                                    position={{
                                      lat: parseFloat(latitude),
                                      lng: parseFloat(longitude),
                                    }}
                                    icon={createRedIcon()}
                                    draggable={true}
                                    onDragEnd={handleMarkerDragEnd}
                                    onClick={() => setInfoWindowOpen(true)}
                                  >
                                    {isInfoWindowOpen && (
                                      <InfoWindowF
                                        position={{
                                          lat: parseFloat(latitude),
                                          lng: parseFloat(longitude),
                                        }}
                                        onCloseClick={() =>
                                          setInfoWindowOpen(false)
                                        }
                                      >
                                        <Box>
                                          <Typography variant="body2">
                                            <b>Latitude:</b> {latitude},{" "}
                                            <b>Longitude:</b> {longitude}
                                          </Typography>
                                          <Typography variant="body2">
                                            {formattedAddress}
                                          </Typography>
                                        </Box>
                                      </InfoWindowF>
                                    )}
                                  </MarkerF>
                                )}

                                {/* Center location message */}
                                <Box
                                  sx={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    bgcolor: "rgba(75, 0, 130, 0.8)",
                                    color: "white",
                                    py: 1,
                                    px: 2,
                                    borderRadius: 2,
                                    textAlign: "center",
                                    zIndex: 1,
                                    pointerEvents: "none",
                                    maxWidth: "80%",
                                  }}
                                >
                                  <Typography variant="body2">
                                    Move the map to adjust your location
                                  </Typography>
                                </Box>
                              </GoogleMap>

                              {/* Location details and address */}
                              <Box
                                sx={{
                                  position: "absolute",
                                  bottom: 0,
                                  left: 0,
                                  right: 0,
                                  bgcolor: "white",
                                  p: 2,
                                  borderBottomLeftRadius: "8px",
                                  borderBottomRightRadius: "8px",
                                }}
                              >
                                <Typography
                                  variant="h6"
                                  sx={{ fontWeight: "bold" }}
                                >
                                  {formattedAddress?.split(",")[0] ||
                                    "Selected Location"}
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                  {formattedAddress}
                                </Typography>
                              </Box>
                            </Box>
                          ) : (
                            <Typography>Loading map...</Typography>
                          )}

                          {/* Confirm Button */}
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              mt: 2,
                            }}
                          >
                            <Button
                              variant="contained"
                              fullWidth
                              onClick={handleConfirmLocation}
                              sx={{
                                bgcolor: "#e91e63",
                                color: "white",
                                "&:hover": { bgcolor: "#c2185b" },
                                py: 1.5,
                                fontWeight: "bold",
                                borderRadius: 2,
                              }}
                            >
                              Confirm & Continue
                            </Button>
                          </Box>
                        </Paper>
                      </Modal>
                      <Box display="flex" flexDirection="row" flexWrap="wrap">
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: "bold",
                            fontSize: "10px",
                            color: "red",
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                            maxWidth: "50%",
                          }}
                        >
                          {formattedAddress}
                        </Typography>
                        <Link
                          href="#"
                          onClick={() => setIsModalOpen(true)}
                          sx={{
                            color: "#4169E1",
                            fontWeight: "bold",
                            fontSize: 10,
                            marginLeft: 1,
                            alignSelf: "flex-start",
                          }}
                        >
                          Change Location
                        </Link>
                      </Box>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      cursor: "pointer",
                    }}
                  >
                    {!customerId && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          cursor: "pointer",
                          ml: 2,
                        }}
                      >
                        <PersonIcon sx={{ color: "orange", fontSize: 38 }} />
                        <Typography
                          variant="body1"
                          sx={{
                            color: "orange",
                            fontWeight: "bold",
                            cursor: "pointer",
                            textDecoration: "none",
                          }}
                          onClick={handleLogin}
                        >
                          Login
                        </Typography>
                        {/* <KeyboardArrowDownIcon
                          sx={{ color: "orange", fontSize: 20 }}
                        /> */}
                      </Box>
                    )}

                    {/* <PersonIcon sx={{ color: "orange", fontSize: 38 }} />
                    <Typography
                      variant="body1"
                      sx={{
                        color: "orange",
                        fontWeight: "bold",
                        cursor: "pointer",
                        textDecoration: "none",
                      }}
                      onClick={handleLogin}
                    >
                      Login
                    </Typography>
                    <KeyboardArrowDownIcon
                      sx={{ color: "orange", fontSize: 20 }}
                    /> */}

                    {customerId && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          cursor: "pointer",
                          ml: 2,
                        }}
                      >
                        <AccountCircleIcon
                          sx={{ color: "orange", fontSize: 38 }}
                        />
                        <Typography
                          variant="body1"
                          sx={{
                            color: "orange",
                            fontWeight: "bold",
                            cursor: "pointer",
                            textDecoration: "none",
                          }}
                          onClick={handleAccount}
                        >
                          Account
                        </Typography>
                        {/* <KeyboardArrowDownIcon
                          sx={{ color: "orange", fontSize: 20 }}
                        /> */}
                      </Box>
                    )}
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    flexWrap: "wrap",
                    gap: 2,
                  }}
                >
                  {/* Search Box */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "#f8f9fa",
                      borderRadius: "30px",
                      width: { xs: "100%", md: "50%" },
                      maxWidth: { xs: "100%", md: 600 },
                      minWidth: 0,
                      flex: { xs: "1 1 100%", md: "0 1 auto" },
                      px: 2,
                      py: 0.5,
                      marginLeft: { xs: 0, md: "17%" },
                      position: "relative",
                      boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
                    }}
                  >
                    <SearchIcon sx={{ color: "#888", mr: 1 }} />

                    <InputBase
                      placeholder="Search Stores or Products..."
                      sx={{ flex: 1, fontSize: "0.95rem" }}
                      value={query}
                      onChange={handleQueryChange}
                      onFocus={() => query?.length > 1 && setOpenDropdown(true)}
                    />

                    <IconButton
                      onClick={() => {
                        if (query.length > 1) {
                          setLoading(true);
                          fetchSearchData(query)
                            .then((data) => {
                              setSearchSuggestions(data);
                              setOpenDropdown(true);
                            })
                            .catch(() => {
                              setSearchSuggestions([]);
                            })
                            .finally(() => {
                              setLoading(false);
                              setOpenDropdown(true);
                            });
                        }
                      }}
                    >
                      <SearchIcon />
                    </IconButton>

                    {openDropdown && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: "110%",
                          left: 0,
                          width: "100%",
                          backgroundColor: "#fff",
                          borderRadius: 3,
                          boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
                          zIndex: 1200,
                          maxHeight: 350,
                          overflowY: "auto",
                        }}
                      >
                        {/* Loader */}
                        {loading && (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              py: 3,
                            }}
                          >
                            <CircularProgress size={25} />
                          </Box>
                        )}

                        {!loading && searchSuggestions?.length === 0 && (
                          <Box
                            sx={{
                              textAlign: "center",
                              py: 3,
                              color: "text.secondary",
                            }}
                          >
                            No results found
                          </Box>
                        )}

                        {/* VENDORS */}
                        {!loading &&
                          searchSuggestions?.filter((s) => s?.type === "vendor")
                            ?.length > 0 && (
                            <>
                              <Typography
                                sx={{
                                  px: 2,
                                  pt: 1,
                                  pb: 0.5,
                                  fontSize: 13,
                                  fontWeight: 600,
                                  color: "#888",
                                }}
                              >
                                VENDORS
                              </Typography>

                              {searchSuggestions
                                ?.filter((s) => s?.type === "vendor")
                                ?.map((s) => (
                                  <Box
                                    key={s?.id}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1.5,
                                      px: 2,
                                      py: 1,
                                      cursor: "pointer",
                                      "&:hover": { backgroundColor: "#f5f5f5" },
                                    }}
                                    onClick={() =>
                                      handleSearchSuggestionClick(s)
                                    }
                                  >
                                    {s?.profile ? (
                                      <img
                                        src={s.profile}
                                        alt={s.label}
                                        style={{
                                          width: 32,
                                          height: 32,
                                          borderRadius: "50%",
                                        }}
                                      />
                                    ) : (
                                      <StoreIcon color="primary" />
                                    )}

                                    <Typography fontSize="0.9rem">
                                      {s?.label}
                                    </Typography>
                                  </Box>
                                ))}
                            </>
                          )}

                        {/* PRODUCTS */}
                        {!loading &&
                          searchSuggestions?.filter(
                            (s) => s?.type === "product",
                          )?.length > 0 && (
                            <>
                              <Typography
                                sx={{
                                  px: 2,
                                  pt: 1,
                                  pb: 0.5,
                                  fontSize: 13,
                                  fontWeight: 600,
                                  color: "#888",
                                }}
                              >
                                PRODUCTS
                              </Typography>

                              {searchSuggestions
                                ?.filter((s) => s?.type === "product")
                                ?.map((s) => (
                                  <Box
                                    key={s?.id}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1.5,
                                      px: 2,
                                      py: 1,
                                      cursor: "pointer",
                                      "&:hover": { backgroundColor: "#f5f5f5" },
                                    }}
                                    onClick={() =>
                                      handleSearchSuggestionClick(s)
                                    }
                                  >
                                    <ShoppingBagIcon
                                      sx={{ color: "#ff9800" }}
                                    />

                                    <Typography fontSize="0.9rem">
                                      {s?.label}
                                    </Typography>
                                  </Box>
                                ))}
                            </>
                          )}
                        {/* STORES */}
                        {/* {!loading &&
                          searchSuggestions?.filter((s) => s?.type === "store")
                            ?.length > 0 && (
                            <>
                              <Typography
                                sx={{
                                  px: 2,
                                  pt: 1,
                                  pb: 0.5,
                                  fontSize: 13,
                                  fontWeight: 600,
                                  color: "#888",
                                }}
                              >
                                STORES
                              </Typography>

                              {searchSuggestions
                                ?.filter((s) => s?.type === "store")
                                ?.map((s) => (
                                  <Box
                                    key={s?.id}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1.5,
                                      px: 2,
                                      py: 1,
                                      cursor: "pointer",
                                      "&:hover": { backgroundColor: "#f5f5f5" },
                                    }}
                                    onClick={() =>
                                      handleSearchSuggestionClick(s)
                                    }
                                  >
                                    {s?.profile ? (
                                      <img
                                        src={s.profile}
                                        alt={s.label}
                                        style={{
                                          width: 32,
                                          height: 32,
                                          borderRadius: "50%",
                                        }}
                                      />
                                    ) : (
                                      <StoreIcon color="primary" />
                                    )}

                                    <Typography fontSize="0.9rem">
                                      {s?.label}
                                    </Typography>
                                  </Box>
                                ))}
                            </>
                          )} */}
                      </Box>
                    )}
                  </Box>
                  {/* Right-Side Buttons */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "auto",
                      gap: 2,
                    }}
                  >
                    <Button
                      startIcon={
                        <Badge
                          badgeContent={cartData ? cartData?.items.length : 0}
                          color="secondary"
                          sx={{
                            "& .MuiBadge-badge": {
                              backgroundColor:
                                cartData?.items.length === 0
                                  ? "white"
                                  : "green",
                              color:
                                cartData?.items.length === 0
                                  ? "black"
                                  : "white",
                            },
                          }}
                        >
                          {loading ? (
                            <CircularProgress size={20} color="inherit" />
                          ) : (
                            <ShoppingCartIcon />
                          )}
                        </Badge>
                      }
                      sx={{
                        color: "black",
                        fontWeight: "bold",
                        textTransform: "none",
                      }}
                      onClick={handleCart}
                    >
                      Cart
                    </Button>
                    <Button
                      variant="contained"
                      sx={{
                        textTransform: "none",
                        backgroundColor: "#e53935",
                        color: "#fff",
                        fontWeight: "bold",
                        borderRadius: "8px",
                        px: 2,
                        boxShadow: "0 2px 6px rgba(229,57,53,0.3)",
                        "&:hover": {
                          backgroundColor: "#d32f2f",
                          boxShadow: "0 4px 10px rgba(229,57,53,0.4)",
                        },
                      }}
                      onClick={() => setIsJoinUsOpen(true)}
                    >
                      Join Us
                    </Button>
                    <Button
                      variant="outlined"
                      sx={{
                        textTransform: "none",
                        borderColor: "red",
                        color: "red",
                        fontWeight: "bold",
                        borderRadius: "8px",
                        "&:hover": {
                          borderColor: "red",
                          backgroundColor: "#fff8e5",
                        },
                      }}
                      onClick={handleVendorseller}
                    >
                      Become a Vendor or Seller
                    </Button>
                  </Box>
                </Box>
              </>
            )}
          </Toolbar>
        </AppBar>
      </Slide>
      <Drawer anchor="left" open={isDrawerOpen} onClose={toggleDrawer(false)}>
        <DrawerContent />
      </Drawer>

      {/* Join Us Dialog Modal */}
      <Dialog
        open={isJoinUsOpen}
        onClose={handleCloseJoinUs}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 1,
            boxShadow: "0 10px 35px rgba(0,0,0,0.2)",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 1,
          }}
        >
          <Box>
            <Typography variant="h6" fontWeight="bold" color="error">
              {joinOtpVerified ? "Vendor Details" : "Join Us"}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {joinOtpVerified
                ? "Complete your profile to get started"
                : "Connect with Sthanick in seconds"}
            </Typography>
          </Box>
          <IconButton onClick={handleCloseJoinUs} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ pt: 1 }}>
          {joinSuccessMsg && (
            <Alert
              severity={joinOtpVerified && !joinName ? "info" : "success"}
              sx={{ mb: 2 }}
            >
              {joinSuccessMsg}
            </Alert>
          )}

          {/* Phone Number Field */}
          <Box sx={{ mb: 2 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 0.5,
              }}
            >
              <Typography
                variant="subtitle2"
                fontWeight="600"
                sx={{ color: "#333" }}
              >
                Phone Number
              </Typography>
              {joinOtpVerified && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    color: "green",
                  }}
                >
                  <CheckCircleIcon sx={{ fontSize: 16 }} />
                  <Typography variant="caption" fontWeight="bold">
                    Verified
                  </Typography>
                </Box>
              )}
            </Box>
            <TextField
              fullWidth
              variant="outlined"
              size="small"
              disabled={joinOtpVerified}
              placeholder="Enter 10-digit mobile number"
              value={joinPhone}
              onChange={handlePhoneInputChange}
              error={Boolean(joinPhoneError)}
              helperText={joinPhoneError}
              inputProps={{
                maxLength: 10,
                inputMode: "numeric",
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        pr: 0.5,
                        borderRight: "1px solid #ddd",
                      }}
                    >
                      <PhoneAndroidIcon sx={{ fontSize: 18, color: "error.main" }} />
                      <Typography variant="body2" fontWeight="600" color="text.secondary">
                        +91
                      </Typography>
                    </Box>
                  </InputAdornment>
                ),
                endAdornment: joinSendingOtp ? (
                  <InputAdornment position="end">
                    <CircularProgress size={18} color="error" />
                  </InputAdornment>
                ) : isPhoneValid && !joinOtpVerified ? (
                  <InputAdornment position="end">
                    <CheckCircleIcon sx={{ color: "green", fontSize: 20 }} />
                  </InputAdornment>
                ) : null,
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  backgroundColor: joinOtpVerified ? "#f0fdf4" : "#fafafa",
                  "&.Mui-focused": {
                    backgroundColor: "#ffffff",
                  },
                },
              }}
            />
            {isPhoneValid && !joinOtpSent && !joinOtpVerified && (
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 0.5 }}>
                <Button
                  size="small"
                  onClick={() => sendJoinOtpRequest(joinPhone)}
                  disabled={joinSendingOtp}
                  sx={{
                    textTransform: "none",
                    fontSize: 12,
                    color: "error.main",
                    fontWeight: "bold",
                  }}
                >
                  {joinSendingOtp ? "Sending OTP..." : "Send OTP"}
                </Button>
              </Box>
            )}
            {joinOtpSent && !joinOtpVerified && (
              <Typography variant="caption" sx={{ color: "green", display: "block", mt: 0.5 }}>
                ✓ OTP sent to +91 {joinPhone}
              </Typography>
            )}
          </Box>

          {/* OTP Section (Shown only before OTP is verified) */}
          {!joinOtpVerified ? (
            <Box
              sx={{
                p: 2,
                borderRadius: 2,
                backgroundColor: isOtpFieldEnabled ? "#fff8f8" : "#f5f5f5",
                border: isOtpFieldEnabled ? "1px solid #ffcdd2" : "1px dashed #ddd",
                transition: "all 0.3s ease",
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                  <LockOutlinedIcon
                    sx={{
                      fontSize: 18,
                      color: isOtpFieldEnabled ? "error.main" : "#9e9e9e",
                    }}
                  />
                  <Typography
                    variant="subtitle2"
                    fontWeight="600"
                    sx={{ color: isOtpFieldEnabled ? "#333" : "#888" }}
                  >
                    Enter 6-Digit OTP
                  </Typography>
                </Box>
                <Typography
                  variant="caption"
                  sx={{
                    color: isOtpFieldEnabled ? "error.main" : "#888",
                    fontWeight: "bold",
                    backgroundColor: isOtpFieldEnabled ? "#ffebee" : "#e0e0e0",
                    px: 1,
                    py: 0.2,
                    borderRadius: 1,
                    fontSize: 10,
                  }}
                >
                  {isOtpFieldEnabled ? "ENABLED" : "DISABLED"}
                </Typography>
              </Box>

              <Typography
                variant="caption"
                color={isOtpFieldEnabled ? "text.secondary" : "text.disabled"}
                sx={{ display: "block", mb: 1.5 }}
              >
                {isOtpFieldEnabled
                  ? "Please enter the 6-digit OTP sent to your phone number."
                  : "Enter a valid 10-digit mobile number above to enable this OTP field."}
              </Typography>

              <Box sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}>
                {joinOtp.map((digit, index) => (
                  <TextField
                    key={index}
                    value={digit}
                    disabled={!isOtpFieldEnabled}
                    inputRef={(el) => (joinOtpInputRefs.current[index] = el)}
                    variant="outlined"
                    size="small"
                    inputProps={{
                      maxLength: 1,
                      inputMode: "numeric",
                      style: {
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "1.1rem",
                        padding: "8px 0",
                      },
                    }}
                    onChange={(e) => handleJoinOtpChange(e, index)}
                    onKeyDown={(e) => handleJoinOtpKeyDown(e, index)}
                    sx={{
                      width: { xs: 38, sm: 46 },
                      backgroundColor: isOtpFieldEnabled ? "#ffffff" : "#f0f0f0",
                      borderRadius: 1.5,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1.5,
                        "& fieldset": {
                          borderColor: isOtpFieldEnabled ? (digit ? "#e53935" : "#ccc") : "#e0e0e0",
                        },
                        "&:hover fieldset": {
                          borderColor: isOtpFieldEnabled ? "#e53935" : "#e0e0e0",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#e53935",
                        },
                      },
                    }}
                  />
                ))}
              </Box>

              {joinOtpError && (
                <Typography color="error" variant="caption" sx={{ display: "block", mt: 1 }}>
                  {joinOtpError}
                </Typography>
              )}

              {isOtpFieldEnabled && joinOtpSent && (
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1.5 }}>
                  {!canResendJoinOtp ? (
                    <Typography variant="caption" color="text.secondary">
                      Resend OTP in <b>{joinTimer < 10 ? `0${joinTimer}` : joinTimer}s</b>
                    </Typography>
                  ) : (
                    <Button
                      size="small"
                      onClick={handleResendJoinOtp}
                      disabled={joinSendingOtp}
                      sx={{
                        p: 0,
                        textTransform: "none",
                        fontSize: 12,
                        color: "error.main",
                        fontWeight: "bold",
                      }}
                    >
                      Resend OTP
                    </Button>
                  )}
                </Box>
              )}
            </Box>
          ) : (
            /* 3 Additional Fields after OTP is verified */
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
              {/* Full Name */}
              <Box>
                <Typography variant="subtitle2" fontWeight="600" sx={{ mb: 0.5, color: "#333" }}>
                  Full Name <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  placeholder="Enter your full name"
                  value={joinName}
                  onChange={(e) => {
                    setJoinName(e.target.value);
                    setJoinNameError("");
                  }}
                  error={Boolean(joinNameError)}
                  helperText={joinNameError}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon sx={{ fontSize: 20, color: "error.main" }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                      backgroundColor: "#fafafa",
                      "&.Mui-focused": {
                        backgroundColor: "#ffffff",
                      },
                    },
                  }}
                />
              </Box>

              {/* Email Address */}
              <Box>
                <Typography variant="subtitle2" fontWeight="600" sx={{ mb: 0.5, color: "#333" }}>
                  Email Address <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  type="email"
                  placeholder="Enter your email address"
                  value={joinEmail}
                  onChange={(e) => {
                    setJoinEmail(e.target.value);
                    setJoinEmailError("");
                  }}
                  error={Boolean(joinEmailError)}
                  helperText={joinEmailError}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon sx={{ fontSize: 20, color: "error.main" }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                      backgroundColor: "#fafafa",
                      "&.Mui-focused": {
                        backgroundColor: "#ffffff",
                      },
                    },
                  }}
                />
              </Box>

              {/* Address */}
              <Box>
                <Typography variant="subtitle2" fontWeight="600" sx={{ mb: 0.5, color: "#333" }}>
                  Address <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  multiline
                  rows={2}
                  placeholder="Enter your address (e.g. Street, City)"
                  value={joinAddress}
                  onChange={(e) => {
                    setJoinAddress(e.target.value);
                    setJoinAddressError("");
                  }}
                  error={Boolean(joinAddressError)}
                  helperText={joinAddressError}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start" sx={{ alignSelf: "flex-start", mt: 0.8 }}>
                        <PlaceIcon sx={{ fontSize: 20, color: "error.main" }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                      backgroundColor: "#fafafa",
                      "&.Mui-focused": {
                        backgroundColor: "#ffffff",
                      },
                    },
                  }}
                />
              </Box>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2.5, pt: 1, flexDirection: "column", gap: 1 }}>
          {!joinOtpVerified ? (
            <Button
              fullWidth
              variant="contained"
              disabled={!isOtpFieldEnabled || joinOtp.join("").length !== 6 || joinVerifyingOtp}
              onClick={handleVerifyJoinOtp}
              sx={{
                backgroundColor: "#e53935",
                color: "#fff",
                fontWeight: "bold",
                py: 1,
                borderRadius: 2,
                textTransform: "none",
                fontSize: "0.95rem",
                boxShadow: "0 3px 10px rgba(229,57,53,0.3)",
                "&:hover": {
                  backgroundColor: "#d32f2f",
                },
                "&:disabled": {
                  backgroundColor: "#e0e0e0",
                  color: "#9e9e9e",
                },
              }}
            >
              {joinVerifyingOtp ? (
                <CircularProgress size={22} color="inherit" />
              ) : (
                "Verify OTP"
              )}
            </Button>
          ) : (
            <Button
              fullWidth
              variant="contained"
              disabled={joinUpdatingDetails || !joinName.trim() || !joinEmail.trim() || !joinAddress.trim()}
              onClick={handleUpdateVendorDetails}
              sx={{
                backgroundColor: "#e53935",
                color: "#fff",
                fontWeight: "bold",
                py: 1,
                borderRadius: 2,
                textTransform: "none",
                fontSize: "0.95rem",
                boxShadow: "0 3px 10px rgba(229,57,53,0.3)",
                "&:hover": {
                  backgroundColor: "#d32f2f",
                },
                "&:disabled": {
                  backgroundColor: "#e0e0e0",
                  color: "#9e9e9e",
                },
              }}
            >
              {joinUpdatingDetails ? (
                <CircularProgress size={22} color="inherit" />
              ) : (
                "Submit Details"
              )}
            </Button>
          )}

          <Typography variant="caption" color="text.secondary" textAlign="center">
            By joining, you agree to our Terms of Service & Privacy Policy
          </Typography>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Header;
